import { Button } from "@flat-ui";
import { useAppNavigation } from "@hooks/navigation/use-app-navigation";
import { useAppParams } from "@router/router-helper";
import { CREDITS_DISPLAY_NAME } from "@src/constants/credit-constants";
import { WorkspaceEvents } from "@utils/track-event/track-event-list";
import { useTrackEvent } from "@utils/track-event/use-track-event";

/** Component to show the button add credits */
export function AddCredits(): JSX.Element {
  const { trackEvent } = useTrackEvent();
  const { companyId } = useAppParams();
  const { navigateToCreditsPage } = useAppNavigation();

  function handleAddCredits(): void {
    trackEvent({
      name: WorkspaceEvents.openAddCreditsPage,
    });

    // Navigate to the add credits page
    if (companyId) {
      navigateToCreditsPage({ companyId });
    }
  }

  return (
    <Button onClick={handleAddCredits}>
      Add {CREDITS_DISPLAY_NAME}
    </Button>
  );
}
